//コレクションフィルター
$(function(){
  $("a.switch-grid-normal").click(function() {
  
    if( $(this).hasClass('active') ) {
      $(this).removeClass('active');
    }else {
      $("a.switch-grid-raw").removeClass('active');
      $(this).addClass('active');
    }
    $("#ProductGridContainer .product-grid--raw").removeClass('active');
    $("#ProductGridContainer .product-grid--grid").addClass('active');
  });
  $("a.switch-grid-raw").click(function() {
  
    if( $(this).hasClass('active') ) {
      $(this).removeClass('active');
    }else {
      $("a.switch-grid-normal").removeClass('active');
      $(this).addClass('active');
    }
    $("#ProductGridContainer .product-grid--grid").removeClass('active');
    $("#ProductGridContainer .product-grid--raw").addClass('active');

  });
});

//page-topボタン(ストアも同様)
var pageTopVisible = false;
$(window).on("scroll" ,function(){
    if( $(window).scrollTop() > 200){
      if (!pageTopVisible) {
        $('.page-top').stop().fadeIn();
        pageTopVisible = true;
      }
    }else{
        if (pageTopVisible) {
          console.log('hide');
          $('.page-top').stop().fadeOut();
          pageTopVisible = false;
        }
    }
});

//slick-slider TOP MV
window.addEventListener('DOMContentLoaded', (event) => {
    $('.slick01').slick({
      autoplay: false,  
      autoplaySpeed: 3000,
      speed: 500,
      dots: true,
      arrows:true,
      centerMode: true,
      centerPadding: '14vw',//16%
      variableWidth: true,
      adaptiveHeight:false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<div class="slide-prev"><div class="prev-arrow"></div></div>',//矢印部分PreviewのHTMLを変更
	  nextArrow: '<div class="slide-next"><div class="next-arrow"></div></div>',//矢印部分NextのHTMLを変更
      responsive: [
        {
			breakpoint: 1199,//
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                centerMode: true,
                centerPadding: '14vw',//16%
                variableWidth: false,
			}
		},
        {
			breakpoint: 990,//
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                arrows:false,
                centerMode: true,
                centerPadding: '1vw',//16%
                variableWidth: false,
			}
		},
			{
			breakpoint: 769,//
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                arrows:false,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
			}
		},
		{
			breakpoint: 426,//
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                arrows:false,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
			}
		}
	]
    });
  
  $('.slick02').slick({
      autoplay: false, 
      autoplaySpeed: 3000,
      speed: 300,
      dots: true,
      arrows:true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.cyg_slider',
      prevArrow: '<div class="slide-prev"><div class="prev-arrow"></div></div>',//矢印部分PreviewのHTMLを変更
	  nextArrow: '<div class="slide-next"><div class="next-arrow"></div></div>',//矢印部分NextのHTMLを変更
      responsive: [
			{
			breakpoint: 769,//モニターの横幅が769px以下の見せ方
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                arrows:true
			}
		},
		{
			breakpoint: 426,//モニターの横幅が426px以下の見せ方
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                arrows:true
			}
		}
	]
    }).on('afterChange', function(event, slick, currentSlide) {
      // var index = $('media-gallery slider-component ul li.slick-current').attr('data-slick-index');  
      $('.slider-counter--current').text(Number(currentSlide)+1);
    });


    $('.slider-nav').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: false,
      asNavFor: '.cyg_slider',
      variableWidth: true,
      dots: false,
      arrows:false,
      focusOnSelect: true
    });
  $('.slick021').slick({
      autoplay: false, 
      autoplaySpeed: 3000,
      speed: 300,
      dots: false,
      arrows:true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slider-nav1',
      prevArrow: '<div class="slide-prev"><div class="prev-arrow"></div></div>',//矢印部分PreviewのHTMLを変更
	  nextArrow: '<div class="slide-next"><div class="next-arrow"></div></div>',//矢印部分NextのHTMLを変更
      responsive: [
			{
			breakpoint: 769,//モニターの横幅が769px以下の見せ方
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                arrows:true
			}
		},
		{
			breakpoint: 426,//モニターの横幅が426px以下の見せ方
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                arrows:true
			}
		}
	]
    }).on('afterChange', function(event, slick, currentSlide) {
      // var index = $('media-gallery slider-component ul li.slick-current').attr('data-slick-index');  
      $('.slider-counter--current1').text(Number(currentSlide)+1);
    });
    let slide021Timeout = null;
    $(window).on('resize', function() {
      // if (slide021Timeout) {
      //   window.clearTimeout(slide021Timeout);
      //   slide021Timeout = true;
      // }
      // slide021Timeout = window.setTimeout(function() {
        $('.slick021').slick('refresh');
      //   slide021Timeout = null;
      // }, 300);
    });

    $('.slider-nav1').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: false,
      asNavFor: '.slick021',
      variableWidth: true,
      dots: false,
      arrows:false,
      focusOnSelect: true
    });
  
  $('#text-slider').slick({
      autoplay: true, 
      autoplaySpeed: 3000,
      speed: 300,
      draggable:true,
      dots: false,
      arrows:true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<div class="slide-prev"></div>',//矢印部分PreviewのHTMLを変更
	  nextArrow: '<div class="slide-next"></div>',//矢印部分NextのHTMLを変更
      responsive: [
			{
			breakpoint: 769,//モニターの横幅が769px以下の見せ方
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                arrows:true,
                centerMode: false,
                centerPadding: '0'
			}
		},
		{
			breakpoint: 426,//モニターの横幅が426px以下の見せ方
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                arrows:true,
                centerMode: false,
                centerPadding: '0'
			}
		}
	]
    });
  
    $('.new-item').slick({
      autoplay: false, 
      autoplaySpeed: 0,
      speed: 300,
      dots: true,
      arrows:true,
      infinite: true,
      initialSlide:0,
      swipeToSlide: true,
      variableWidth: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      cssEase: 'linear',
      prevArrow: '<div class="slide-prev"><div class="prev-arrow"></div></div>',//矢印部分PreviewのHTMLを変更
	    nextArrow: '<div class="slide-next"><div class="next-arrow"></div></div>',//矢印部分NextのHTMLを変更
      responsive: [
        {
          breakpoint: 990, //モニターの横幅が769px以下の見せ方
          settings: {
            speed: 100, // スマホの場合きびきび
            slidesToShow: 2,
            slidesToScroll: 1, // MEMO: centerModeの際にはこの値は関係なくなるので、もし設定したいなら初期化の後設定する必要がある
            arrows:false,
            centerMode: true,
            initialSlide:0
          }
        },
      ]
  //     responsive: [
  //       {
  //         breakpoint: 1199,
  //         settings: {
  //             slidesToShow: 2,
  //             slidesToScroll: 2,
  //             arrows:false,
  //             centerMode: false,
  //             centerPadding: '0'
  //         }
	// 	    },
  //       {
  //         breakpoint: 769,//モニターの横幅が769px以下の見せ方
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 2,
  //           arrows:false,
  //           centerMode: true,
  //           centerPadding: '0',
  //           initialSlide:0
  //         }
  //       },
	// 	    {
  //         breakpoint: 426,//モニターの横幅が426px以下の見せ方
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 2,
  //           arrows:false,
  //           variableWidth: false,
  //           centerMode: true,
  //           centerPadding: '21.86vw', // 38.4/2+2.66
  //           initialSlide:1
  //         }
  //       },
  //       {
  //       breakpoint: 375,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2,
  //         arrows:false,
  //         variableWidth: false,
  //         centerMode: true,
  //         centerPadding: '21.86vw', // 38.4/2+2.66
  //         initialSlide:1
	// 		}
	// 	}
	// ]
  });

  $(".ranking-slide").slick({
      autoplay: false, 
      autoplaySpeed: 0,
      speed: 300,
      dots: false,
      arrows:true,
      infinite: false,
      variableWidth: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      cssEase: 'linear',
      prevArrow: '<div class="slide-prev"></div>',//矢印部分PreviewのHTMLを変更
	  nextArrow: '<div class="slide-next"><div class="next-arrow"></div></div>',//矢印部分NextのHTMLを変更
      responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows:true,
                    centerMode: false,
                    centerPadding: '0'
                }
            },
			{
			breakpoint: 749,//モニターの横幅が769px以下の見せ方
			settings: "unslick",
		}
	]
    });

    $(window).on("resize orientationchange", function () {
      $(".ranking-slide").slick("resize");
    });

  
  $(".recommend-item").slick({
      autoplay: false, 
      autoplaySpeed: 0,
      speed: 300,
      dots: false,
      arrows:true,
      infinite: true,
      variableWidth: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      cssEase: 'linear',
      prevArrow: '<div class="slide-prev"></div>',//矢印部分PreviewのHTMLを変更
	  nextArrow: '<div class="slide-next"><div class="next-arrow"></div></div>',//矢印部分NextのHTMLを変更
      responsive: [
			{
			breakpoint: 769,//モニターの横幅が769px以下の見せ方
			settings: "unslick",
		}
	]
    });

    $(window).on("resize orientationchange", function () {
      $(".recommend-item").slick("resize");
    });
  
  
  $(".recommend_products").slick({
      autoplay: false, 
      autoplaySpeed: 0,
      speed: 300,
      dots: false,
      arrows:true,
      infinite: true,
      variableWidth: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      cssEase: 'linear',
      prevArrow: '<div class="slide-prev"></div>',//矢印部分PreviewのHTMLを変更
	  nextArrow: '<div class="slide-next"><div class="next-arrow"></div></div>',//矢印部分NextのHTMLを変更
      responsive: [
			{
			breakpoint: 769,//モニターの横幅が769px以下の見せ方
			settings: "unslick",
		}
	]
    });

    $(window).on("resize orientationchange", function () {
      $(".recommend_products").slick("resize");
    });
  
  
});




// collections-tab.liquid
document.addEventListener("DOMContentLoaded", function () {
  // タブに対してクリックイベントを適用
  const tabs = document.getElementsByClassName("js-tab");
  for (let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener("click", tabSwitch);
  }

  // タブをクリックすると実行する関数
  function tabSwitch() {
    // 引数で指定したセレクターと一致する直近の祖先要素を取得
    const ancestorEle = this.closest(".js-tab-panel");
    // タブのclassの値を変更
    const active_tab_classes = "bg-active";
    const inactive_tab_classes = "hover:bg-gray-100";
    ancestorEle
      .getElementsByClassName(active_tab_classes)[0]
      .classList.add(inactive_tab_classes);
    ancestorEle
      .getElementsByClassName(active_tab_classes)[0]
      .classList.remove(active_tab_classes);
    this.classList.add(active_tab_classes);
    this.classList.remove(inactive_tab_classes);

    // コンテンツのclassの値を変更
    const active_content_classes = "block";
    const inactive_content_classes = "hidden";
    const targetEle = ancestorEle.getElementsByClassName(
      active_content_classes
    )[0];
    targetEle.classList.remove(active_content_classes);
    targetEle.classList.add(inactive_content_classes);

    const groupTabs = ancestorEle.getElementsByClassName("js-tab");
    const arrayTabs = Array.prototype.slice.call(groupTabs);
    const index = arrayTabs.indexOf(this);
    const targetPanel = ancestorEle.getElementsByClassName("js-panel")[index];
    targetPanel.classList.add(active_content_classes);
    targetPanel.classList.remove(inactive_content_classes);

  }
});


// アンカーリンク
$(function(){
  var headerHeight = $('header').outerHeight();
  var urlHash = location.hash;
  if(urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
      var target = $(urlHash);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({scrollTop:position}, 500);
    }, 100);
  }
  $('a[href^="#"]').click(function(){
    if (location.pathname.startsWith('/account')) return true; // MEMO: account path need to use hash based URLs
    var href= $(this).attr("href");
    console.log('smooth', href);
    var target = $(href);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({scrollTop:position}, 500);
    return false;
  });
});


